/* One volatile cart-note draft shared by native main/drawer forms. */
(() => {
 'use strict';
 function createStore({initial='',write,changed=()=>{}}){
  let draft=String(initial||''),saved=draft,pending=0,error=null,tail=Promise.resolve(),lastSignature=null,lastWork=null;
  const dirty=()=>draft!==saved;
  function set(value){value=String(value??'');if(value!==draft){draft=value;changed();}}
  function receive(value){if(!pending&&!error&&!dirty()){draft=saved=String(value||'');changed();}}
  function save(){
   const payload=draft;if(pending&&lastSignature===payload)return lastWork;
   if(!pending&&!error&&!dirty())return Promise.resolve();
   pending++;lastSignature=payload;changed();
   const request=tail.then(()=>write(payload));
   lastWork=request.then(result=>{saved=result?.cart&&Object.prototype.hasOwnProperty.call(result.cart,'note')?String(result.cart.note??''):payload;if(draft===payload)draft=saved;error=null;return result;},problem=>{error=problem;throw problem;}).finally(()=>{pending--;changed();});
   tail=lastWork.catch(()=>{});return lastWork;
  }
  return {set,receive,save,value:()=>draft,dirty,pending:()=>pending,error:()=>error,ready:()=>!pending&&!error&&!dirty()};
 }
 window.LiotroNotes={createStore};
 if(typeof document==='undefined'||!window.LiotroLifecycle||!window.LiotroCommerce)return;
 let warning='',acting=false;
 const initial=JSON.parse(document.querySelector('#liotro-data').textContent).cart?.note||'';
 const store=createStore({initial,write:note=>window.LiotroCommerce.update({note},{renderSections:false}),changed:sync});
 function sync(){
  document.querySelectorAll('[data-liotro-note],[data-liotro-note-value]').forEach(field=>{
   if(field.value!==store.value())field.value=store.value();
   if(store.pending())field.setAttribute('aria-busy','true');else field.removeAttribute('aria-busy');
  });
  const message=store.error()?window.LiotroText('liotro.notes.failed'):warning;
  document.querySelectorAll('[data-liotro-note-feedback]').forEach(root=>{const status=root.querySelector('[data-liotro-note-status]'),retry=root.querySelector('[data-liotro-note-retry]');status.textContent=message;status.hidden=!message;retry.hidden=!store.error();});
  document.querySelectorAll('[data-liotro-drawer-wallets]').forEach(root=>{root.hidden=!store.ready()||root.closest('[data-liotro-paused]')?.dataset.liotroPaused==='true'||typeof cfg!=='undefined'&&cfg.paused;});
  window.LiotroInvoice?.forEach?.(instance=>instance.changed());
 }
 const instances=window.LiotroLifecycle.create({selector:'[data-liotro-note]',setup(field){
  const input=()=>{warning='';store.set(field.value);};
  const change=()=>{store.set(field.value);store.save().catch(()=>{});};
  field.addEventListener('input',input);field.addEventListener('change',change);
  return {dispose(){field.removeEventListener('input',input);field.removeEventListener('change',change);}};
 }});
 Object.assign(window.LiotroNotes,instances,{ready:store.ready,mount(root){instances.mount(root);sync();}});
 document.addEventListener('liotro:cart-updated',event=>store.receive(event.detail.cart.note));
 document.addEventListener('click',event=>{if(event.target.closest?.('[data-liotro-note-retry]'))store.save().catch(()=>{});});
 function resolveAction(action){
  if(store.ready()){action();return;}
  warning=window.LiotroText('liotro.notes.changed');sync();document.querySelector('[data-liotro-note]')?.focus();
 }
 const paused=form=>form.closest('[data-liotro-paused]')?.dataset.liotroPaused==='true'||typeof cfg!=='undefined'&&cfg.paused;
 const passOnce=new WeakSet();
 document.addEventListener('submit',event=>{
  const form=event.target,button=event.submitter;
  if(event.defaultPrevented||!['LiotroCart','LiotroDrawerCart'].includes(form.id)||button?.name!=='checkout')return;
  if(paused(form)){event.preventDefault();return;}
  if(passOnce.has(form)){passOnce.delete(form);return;}
  if(store.ready())return;
  event.preventDefault();if(acting)return;acting=true;
  button.setAttribute('data-liotro-note-busy','');button.setAttribute('aria-busy','true');const id=form.id;
  store.save().then(()=>resolveAction(()=>{
   const current=document.getElementById(id),submitter=current?.querySelector('[name="checkout"]');if(!current||!submitter||submitter.disabled||paused(current))return;
   passOnce.add(current);try{current.requestSubmit(submitter);}finally{passOnce.delete(current);}
  })).catch(()=>{}).finally(()=>{
   acting=false;const current=document.getElementById(id)?.querySelector('[name="checkout"]');for(const node of new Set([button,current]))if(node?.hasAttribute('data-liotro-note-busy')){node.removeAttribute('data-liotro-note-busy');node.removeAttribute('aria-busy');}
  });
 },true);
 document.addEventListener('click',event=>{
  const link=event.target.closest?.('[data-liotro-cart-link], #LiotroDrawerCart a.button[href]');if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target&&link.target!=='_self')return;
  const url=new URL(link.href,location.origin),samePage=url.origin===location.origin&&url.pathname===location.pathname;
  if(store.ready()&&!samePage)return;
  event.preventDefault();if(acting)return;
  const proceed=()=>{if(samePage){document.querySelector('#cart-drawer')?.close();document.body.classList.toggle('dialog-open',Boolean(document.querySelector('dialog[open]')));}else location.assign(url.href);};
  if(store.ready()){proceed();return;}
  acting=true;link.setAttribute('aria-busy','true');store.save().then(()=>resolveAction(proceed)).catch(()=>{}).finally(()=>{acting=false;link.removeAttribute('aria-busy');});
 });
 window.LiotroNotes.mount(document);
})();
